import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-info-popup',
  templateUrl: './info-popup.component.html',
  styleUrls: ['./info-popup.component.less']
})
export class InfoPopupComponent implements OnInit {

  @Input() info: boolean;
  @Input() copyButton: boolean = true;
  @Output() infoChange = new EventEmitter<boolean>();
  @Input() title: string;
  @Input() text1: string;
  @Input() text2: string;
  @Output() copiedText = new EventEmitter<string>();


  constructor() { }

  ngOnInit() {
    this.title = this.title == undefined ? 'Info' : this.title;
  }

  close() {
    this.infoChange.emit(false);
  }

  copyText() {
    this.copiedText.emit(this.text2);
    this.infoChange.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/info-popup/info-popup.component.ts